import { differenceInMinutes } from 'date-fns';

const isWithinMinutesFromNowUTC = (date: string, minutes: number) =>
  Math.abs(differenceInMinutes(new Date(date + 'Z'), new Date())) < minutes;

export default isWithinMinutesFromNowUTC;
